import React, { useState } from 'react';
import classNames from 'classnames';

/* Gjensidige Core 20 Imports */
import utils from '@gjensidige/core-utilities-css';

/* Gjensidige Core 30 Imports */
import { Col, Container, Row } from '@gjensidige/nci-core-grid';
import { Dropdown } from '@gjensidige/core-components/lib/forms/dropdown';
import { Title } from '@gjensidige/nci-core-typography';

/* Shared Imports */
import ClaimReportGlasses from './ClaimReportGlasses';
import ClaimReportBuilding from './ClaimReportBuilding';
import ClaimReportEnterprise from './ClaimReportEnterprise';
import ClaimReportMachine from './ClaimReportMachine';
import ClaimReportMotorVehicle from './ClaimReportMotorVehicle';
import ClaimReportTheft from './ClaimReportTheft';
import ClaimReportLiabilityDamage from './ClaimReportLiabilityDamage';

const SkadeDIByggeri = () => {
  const [claimType, setClaimType] = useState('');

  const onDropdownChange = (value: string) => {
    setClaimType(value);
  };

  const dropDownOptions = [
    'Ansvarsskade',
    'Brilleskade',
    'Bygningsskade',
    'Entrepriseskade',
    'Maskinskade',
    'Motorkøretøj',
    'Tyveri'
  ];

  const renderReport = () => {
    switch (claimType) {
      case 'Ansvarsskade':
        return <ClaimReportLiabilityDamage claimType={claimType} />;
      case 'Brilleskade':
        return <ClaimReportGlasses claimType={claimType} />;
      case 'Bygningsskade':
        return <ClaimReportBuilding claimType={claimType} />;
      case 'Entrepriseskade':
        return <ClaimReportEnterprise claimType={claimType} />;
      case 'Maskinskade':
        return <ClaimReportMachine claimType={claimType} />;
      case 'Motorkøretøj':
        return <ClaimReportMotorVehicle claimType={claimType} />;
      case 'Tyveri':
        return <ClaimReportTheft claimType={claimType} />;
      default:
        return null;
    }
  };

  return (
    <Container className={utils['mt-2']}>
      <Row
        className={classNames(utils['mb-3'], utils['justify-content-center'])}
      >
        <Col lg={6}>
          <Title tag="h4">Anmeld skade</Title>
        </Col>
      </Row>
      <Row className={utils['justify-content-center']}>
        <Col lg={6}>
          <Dropdown
            name="claimType"
            id="claim-type"
            labelText="Hvilken skade vil du anmelde?"
            className={utils['pb-2']}
            options={dropDownOptions.map((option) => ({
              labelText: option,
              value: option
            }))}
            value={claimType}
            onChange={(value) => onDropdownChange(value)}
          />
        </Col>
      </Row>
      <Row className={utils['justify-content-center']}>
        <Col lg={6}>{renderReport()}</Col>
      </Row>
    </Container>
  );
};

export default SkadeDIByggeri;
